import React, { useState, useEffect } from 'react'
import { Fade } from 'react-awesome-reveal'
// import { Modal, Button } from 'react-bootstrap'  // kept for modal re-enable

const KwikTripDropLiveCF10324 = ({ role, shipment, parentShipment, stopType, multiShipmentApptModeOrders }) => {
    const [loading, setLoading] = useState(false)
    const [liveOrDrop, setLiveOrDrop] = useState(null)
    const [stopSelections, setStopSelections] = useState([])

    // Modal-mode state — kept for future re-enable
    // const [showMultiOrderModal, setShowMultiOrderModal] = useState(false)
    // const [deliveryStopName, setDeliveryStopName] = useState('')
    // const [loadingOrders, setLoadingOrders] = useState(new Set())

    // console.log('KwikTripDropLiveCF10324 shipment', shipment )
    // console.log('KwikTripDropLiveCF10324 parentShipment', parentShipment )
    // console.log('KwikTripDropLiveCF10324 multiShipmentApptModeOrders', multiShipmentApptModeOrders )
    // console.log('KwikTripDropLiveCF10324 stopType', stopType)

    useEffect(() => {
        if (shipment?.customFields) {
            let liveOrDropCF = shipment.customFields.find(cf => cf.fieldID === 10324)
            if (liveOrDropCF && liveOrDropCF.fieldValue !== liveOrDrop) {
                setLiveOrDrop(liveOrDropCF.fieldValue)
            }
        }
    }, [shipment, parentShipment]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!parentShipment?.stops || !shipment?.id) return
        const deliveryStop = parentShipment.stops.find(
            s => s.type === 'Delivery' && s.orders?.some(o => o.id === String(shipment.id))
        )
        if (deliveryStop) {
            // setDeliveryStopName(`Stop ${deliveryStop.stopNumber} — ${deliveryStop.name}`)
            setStopSelections(
                deliveryStop.orders.map(o => ({
                    orderId: o.id,
                    usercontrol: o.usercontrol,
                    liveOrDrop: o.customfieldValues?.field10324 ?? null,
                    items: (o.handlingUnits ?? []).flatMap(hu => hu.items ?? [])
                }))
            )
        } else {
            // setDeliveryStopName('')
            setStopSelections([])
        }
    }, [parentShipment, shipment])

    useEffect(() => {
        if (!multiShipmentApptModeOrders?.length || parentShipment) return
        setStopSelections(
            multiShipmentApptModeOrders.map(s => ({
                orderId: s.id,
                usercontrol: s.trackingNumber || s.usercontrol || String(s.id),
                liveOrDrop: s.customfieldValues?.field10324 ??
                    s.customFields?.find(cf => cf.fieldID === 10324)?.fieldValue ?? null,
                items: (s.handlingUnits ?? []).flatMap(hu => hu.items ?? [])
            }))
        )
    }, [multiShipmentApptModeOrders, parentShipment])

    if (stopType === 'Pickup') return null

    // Per-order modal handler — kept for future re-enable
    // const handleMultiOrderRadioClick = async (orderId, choice, idx) => {
    //     if (loadingOrders.has(orderId) || stopSelections[idx].liveOrDrop === choice) return
    //     setLoadingOrders(prev => new Set([...prev, orderId]))
    //     const updated = [...stopSelections]
    //     updated[idx] = { ...updated[idx], liveOrDrop: choice }
    //     setStopSelections(updated)
    //     await updateLiveOrDropViaShipmentV4(orderId, choice)
    //     setLoadingOrders(prev => { const next = new Set(prev); next.delete(orderId); return next })
    // }

    const handleLiveOrDropClick = (choice) => {
        if (loading || liveOrDrop === choice) return

        setLoading(true)
        setLiveOrDrop(choice)

        if (stopSelections.length > 0) {
            stopSelections.forEach(order => updateLiveOrDropViaShipmentV4(order.orderId, choice))
        } else {
            updateLiveOrDropViaShipmentV4(shipment.id, choice)
        }
    }

    const updateLiveOrDropViaShipmentV4 = async (webquotecontrol, choice) => {

        let url = `https://api.shippersedge.com/v4/shipment/` + webquotecontrol
        let body = {
            forceUpdate: true,
            customfieldValues: { field10324: choice }
        }

        try {
            let response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'x-api-Key': 'vdhy8wwjUJrwhxFpfuECTiAW'
                },
                body: JSON.stringify(body)
            })

            let data
            try {
                data = await response.json()
            } catch (err) {
                console.error('KwikTripDropLiveCF10324 updateLiveOrDropViaShipmentV4 error', err)
            }

            if (response.status !== 200 || !data) {
                console.error('KwikTripDropLiveCF10324 updateLiveOrDropViaShipmentV4 unexpected response', response.status, data)
            }
        } catch (error) {
            console.error('KwikTripDropLiveCF10324 updateLiveOrDropViaShipmentV4 fetch error', error)
        } finally {
            setLoading(false)
        }
    }

    const notReady = !role || !shipment

    // Per-order modal UI — kept for future re-enable if client wants per-order selection
    // const isApptEditorMultiMode = !parentShipment && (multiShipmentApptModeOrders?.length ?? 0) > 1
    // const isMultiOrder = !!parentShipment && shipment.id !== parentShipment.id && parentShipment?.stops?.length > 1

    // if (isApptEditorMultiMode) {
    //     return (
    //         <>
    //             <div className="card mt-2" style={{ minHeight: '60px' }}>
    //                 <div className="card-body d-flex flex-column justify-content-center">
    //                     <button
    //                         className="btn btn-secondary w-100"
    //                         style={{ fontSize: '1rem' }}
    //                         onClick={() => setShowMultiOrderModal(true)}
    //                     >
    //                         Live /<br />Drop
    //                     </button>
    //                 </div>
    //             </div>
    //             <Modal show={showMultiOrderModal} onHide={() => setShowMultiOrderModal(false)} size="lg">
    //                 <Modal.Header>
    //                     <Modal.Title>Set Live / Drop</Modal.Title>
    //                     <button type="button" className="close" onClick={() => setShowMultiOrderModal(false)} aria-label="Close"
    //                         style={{ border: 'none', background: 'none', padding: 0, fontSize: '1.5rem', lineHeight: 1, opacity: 0.5 }}>
    //                         <span aria-hidden="true">&times;</span>
    //                     </button>
    //                 </Modal.Header>
    //                 <Modal.Body>
    //                     {stopSelections.length === 0 && <p className="text-muted">No shipments found.</p>}
    //                     {stopSelections.map((order, idx) => (
    //                         <div key={order.orderId} className="card mb-3">
    //                             <div className="card-header fw-semibold">Order {order.usercontrol}</div>
    //                             <div className="card-body pb-2">
    //                                 {order.items?.length > 0 && (
    //                                     <table className="table table-sm table-borderless mb-3" style={{ fontSize: '0.8rem' }}>
    //                                         <thead className="text-muted"><tr><th>Description</th><th className="text-end">Qty</th></tr></thead>
    //                                         <tbody>{order.items.map(item => (<tr key={item.id}><td>{item.description}</td><td className="text-end">{item.quantity} {item.quantityUOM}</td></tr>))}</tbody>
    //                                     </table>
    //                                 )}
    //                                 <div className="d-flex gap-3">
    //                                     <div className="form-check">
    //                                         <input className="form-check-input" type="radio" name={`liveOrDrop-order-${order.orderId}`} id={`live-order-${order.orderId}`}
    //                                             checked={order.liveOrDrop === 'live'} disabled={loadingOrders.has(order.orderId)} onChange={() => handleMultiOrderRadioClick(order.orderId, 'live', idx)} />
    //                                         <label className="form-check-label" htmlFor={`live-order-${order.orderId}`}>Live</label>
    //                                     </div>
    //                                     <div className="form-check">
    //                                         <input className="form-check-input" type="radio" name={`liveOrDrop-order-${order.orderId}`} id={`drop-order-${order.orderId}`}
    //                                             checked={order.liveOrDrop === 'drop'} disabled={loadingOrders.has(order.orderId)} onChange={() => handleMultiOrderRadioClick(order.orderId, 'drop', idx)} />
    //                                         <label className="form-check-label" htmlFor={`drop-order-${order.orderId}`}>Drop</label>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     ))}
    //                 </Modal.Body>
    //                 <Modal.Footer><Button variant="secondary" onClick={() => setShowMultiOrderModal(false)}>Close</Button></Modal.Footer>
    //             </Modal>
    //         </>
    //     )
    // } else if (isMultiOrder) {
    //     return (
    //         <>
    //             <div className="card mt-2" style={{ minHeight: '60px' }}>
    //                 <div className="card-body d-flex flex-column justify-content-center">
    //                     <button className="btn btn-secondary w-100" style={{ fontSize: '1rem' }} onClick={() => setShowMultiOrderModal(true)}>
    //                         Set Live or Drop for orders at this stop
    //                     </button>
    //                 </div>
    //             </div>
    //             <Modal show={showMultiOrderModal} onHide={() => setShowMultiOrderModal(false)} size="lg">
    //                 <Modal.Header>
    //                     <Modal.Title>{deliveryStopName || 'Multi-Order Shipment'}</Modal.Title>
    //                     <button type="button" className="close" onClick={() => setShowMultiOrderModal(false)} aria-label="Close"
    //                         style={{ border: 'none', background: 'none', padding: 0, fontSize: '1.5rem', lineHeight: 1, opacity: 0.5 }}>
    //                         <span aria-hidden="true">&times;</span>
    //                     </button>
    //                 </Modal.Header>
    //                 <Modal.Body>
    //                     {stopSelections.length === 0 && <p className="text-muted">No delivery stop found for this shipment.</p>}
    //                     {stopSelections.map((order, idx) => (
    //                         <div key={order.orderId} className="card mb-3">
    //                             <div className="card-header fw-semibold">Order {order.usercontrol}</div>
    //                             <div className="card-body pb-2">
    //                                 {order.items?.length > 0 && (
    //                                     <table className="table table-sm table-borderless mb-3" style={{ fontSize: '0.8rem' }}>
    //                                         <thead className="text-muted"><tr><th>Description</th><th className="text-end">Qty</th></tr></thead>
    //                                         <tbody>{order.items.map(item => (<tr key={item.id}><td>{item.description}</td><td className="text-end">{item.quantity} {item.quantityUOM}</td></tr>))}</tbody>
    //                                     </table>
    //                                 )}
    //                                 <div className="d-flex gap-3">
    //                                     <div className="form-check">
    //                                         <input className="form-check-input" type="radio" name={`liveOrDrop-order-${order.orderId}`} id={`live-order-${order.orderId}`}
    //                                             checked={order.liveOrDrop === 'live'} disabled={loadingOrders.has(order.orderId)} onChange={() => handleMultiOrderRadioClick(order.orderId, 'live', idx)} />
    //                                         <label className="form-check-label" htmlFor={`live-order-${order.orderId}`}>Live</label>
    //                                     </div>
    //                                     <div className="form-check">
    //                                         <input className="form-check-input" type="radio" name={`liveOrDrop-order-${order.orderId}`} id={`drop-order-${order.orderId}`}
    //                                             checked={order.liveOrDrop === 'drop'} disabled={loadingOrders.has(order.orderId)} onChange={() => handleMultiOrderRadioClick(order.orderId, 'drop', idx)} />
    //                                         <label className="form-check-label" htmlFor={`drop-order-${order.orderId}`}>Drop</label>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     ))}
    //                 </Modal.Body>
    //                 <Modal.Footer><Button variant="secondary" onClick={() => setShowMultiOrderModal(false)}>Close</Button></Modal.Footer>
    //             </Modal>
    //         </>
    //     )
    // }

    return (
        <Fade cascade={false} duration={0}>
            <div id="dropLive" className='card mt-2 d-flex flex-row position-relative' style={{ minHeight: '60px' }}>
                {loading && (
                    <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75" style={{ top: 0, left: 0, zIndex: 10 }}>
                        <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
                        </div>
                    </div>
                )}

                <div id="dropLiveInfo" className="card-body d-flex flex-column justify-content-center" style={{ pointerEvents: (loading || notReady) ? 'none' : 'auto' }}>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="liveOrDrop"
                            id="live"
                            checked={liveOrDrop === 'live'}
                            disabled={loading || notReady}
                            onChange={() => handleLiveOrDropClick('live')}
                        />
                        <label className="form-check-label" htmlFor="live">
                            Live {role === "carrier" ? <>Shipment</> : null}
                        </label>
                    </div>

                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="liveOrDrop"
                            id="drop"
                            checked={liveOrDrop === 'drop'}
                            disabled={loading || notReady}
                            onChange={() => handleLiveOrDropClick('drop')}
                        />
                        <label className="form-check-label" htmlFor="drop">
                            Drop {role === "carrier" ? <>Shipment</> : null}
                        </label>
                    </div>
                </div>
            </div>
        </Fade>
    )
}

export default KwikTripDropLiveCF10324
